<template>
  <div class="locale-changer">
    <div v-bind:class="[`flag-selected`, `flag`, `flag-${$i18n.locale}`]" @click="openMenuLangs">
      <span>{{$i18n.locale}}</span>
    </div>
    <ul @focusout="outsideMenuLangsClick" tabindex="0" v-bind:class="[`active-${$i18n.locale}`]">
      <li v-for="(lang, i) in langs" :key="`Lang${i}`" @click="langSelected(lang.code)" :class="lang.code">
        <i v-bind:class="[`flag`, `flag-${lang.code}`]" aria-hidden="true"></i> 
        <span>{{ lang.name }}</span>
      </li>    
    </ul>
  </div>
</template>

<script>

import moment from 'moment'

export default {
  name: 'locale-changer',
  data () {
    return { 
      langs: [
        {
          code: 'fr',
          name: "Français"
        }, 
        {
          code: 'en',
          name: "English"
        }
      ], 
      openSelectLang: false
    }
  },
  methods: {
    saveLocale(locale){
      localStorage.setItem('language', locale)
      moment.locale(locale)

      // recharge les parametre mailmunch
      if(document.body.querySelector("#mailmunch-contact") != null){
        document.body.querySelector("#mailmunch-contact").innerHTML = "" 
        document.body.querySelector("#mailmunch-contact").classList = ""
        document.body.querySelector("#mailmunch-contact").classList.add('$t("home.contact.general.form")')
      }
      else if ((document.body.querySelector(".offre.publishing .cta a") != null) && (document.body.querySelector(".offre.curation .cta a") != null)){
        document.body.querySelector(".offre.publishing .cta a").setAttribute('href', "$t('home.offers.publishing.cta.link')")
        document.body.querySelector(".offre.curation .cta a").setAttribute('href', "$t('home.offers.curation.cta.link')")
      }
      //update script mailmunch
      if(document.head.querySelector("#mailmunch-script") != null)
        document.head.querySelector("#mailmunch-script").remove()
      let mailMunchScript = document.createElement('script')
      mailMunchScript.setAttribute('src', '//a.mailmunch.co/app/v1/site.js')
      mailMunchScript.setAttribute('id', 'mailmunch-script')
      mailMunchScript.setAttribute('data-mailmunch-site-id', '709732')
      mailMunchScript.setAttribute('async', 'async')
      document.head.appendChild(mailMunchScript)
    },
    openMenuLangs: () => {
      document.body.querySelectorAll( ".locale-changer ul").forEach(element => element.classList.toggle("show"))
      document.body.querySelector( ".locale-changer ul").focus()
    },
    async langSelected(lang) {
      this.$i18n.locale = lang
      this.saveLocale(lang)
      document.body.querySelectorAll( ".locale-changer ul").forEach(element => element.classList.remove("show"))
      this.$emit('local-change', lang)
    },
    outsideMenuLangsClick : () => {
      document.body.querySelectorAll( ".locale-changer ul").forEach(element => element.classList.remove("show"))
    }
  }
}
</script>

<style src="../../assets/flags.css" scoped></style>
<style scoped>
  .locale-changer {
    position: relative;
    display: inline-block;
  }

  .locale-changer .flag-selected { 
    position: relative;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .flag.flag-selected:before {
    left: initial;
  }
  .locale-changer ul {
     display: none;
  }
  .locale-changer ul:focus {
    border: 0;
    outline: none;
  }
  .locale-changer ul.show {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: #2459a0;
    color: #fff;
    padding-left: 30px;
    margin: auto;
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
    margin-top: 10px;
    position: absolute;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
  }
  .locale-changer li { 
    position: relative;
    padding: 8px 15px;
    font-size: 16px;
    line-height: 25px;
    cursor: pointer;
  }
  
  .locale-changer ul.active-en li.en {
    display:none;
  }
  .locale-changer ul.active-fr li.fr {
    display:none;
  }

  /* desktop */
  @media (min-width: 992px){
    .locale-changer ul.show {
      left: initial;
      right: 0;
      transform: initial;
    }
  }
</style>